module.exports = __webpack_public_path__ + "static/img/townsend3.bca8632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/townsend3.jpg
// module id = vyhf
// module chunks = 1